import React, { useEffect } from "react";
import logo from "./logo.svg";
import "./App.css";
import NavigationBar from "./components/NavigationBar";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Upload from "./pages/Upload";
import ResetPassword from "./pages/ResetPassword";
import Login from "./pages/Login";
import AboutUs from "./pages/AboutUs";
import { useStore } from "./store";
import Registration from "./pages/Registration";
import AccountActivation from "./pages/AccountActivation";
import ForgotPassword from "./pages/ForgotPassword";
import DataSource from "./pages/DataSource";
import UseCase from "./pages/UseCase";
import Action from "./pages/Action";
import UseCaseDetails from "./pages/UseCaseDetails";
import Footer from "./components/Footer";
import CreditRisk from "./pages/CreditRisk";
import axios from "axios";
import CreditModal from "./components/CreditModal";
import Billing from "./pages/Billing";
import { GoogleOAuthProvider } from '@react-oauth/google';
import CookieConsent from "react-cookie-consent";
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';

// Create a global Axios instance
export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_HOST,
});

export function getUserFilesNames(setUserFilesNames: (data: string[]) => void) {
  axiosInstance
    .get(process.env.REACT_APP_API_HOST + "get_user_files", {
      headers: {
        "Content-Type": "application/json",
        "Referrer-Policy": "no-referrer",
        Authorization: "Bearer " + localStorage.getItem("tokenLida"),
      },
    })
    .then((response) => {
      setUserFilesNames(response.data);
    })
    .catch((error) => {
      console.error("Error fetching user files:", error);
    });
}

function App() {
  const { auth, setAuth } = useStore();
  const { userFilesNames, setUserFilesNames, setShowPaymentModal, showPaymentModal } = useStore();

  useEffect(() => {
    // Add Axios response interceptor globally
    const responseInterceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response && error.response.status === 402) {
          setShowPaymentModal(true);
        }
        return Promise.reject(error);
      }
    );

    // Cleanup interceptor when component unmounts
    return () => {
      axiosInstance.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  useEffect(() => {
    if (auth) {
      getUserFilesNames(setUserFilesNames);
    }
  }, [auth]);

  const closePaymentModal = () => {
    setShowPaymentModal(false);
  };

  return (
    <>
      <Router>
        {auth && <CreditModal isOpen={showPaymentModal} onClose={closePaymentModal} />}
        <NavigationBar />
        <Routes>
          <Route path="/upload" element={auth ? <Upload /> : <Navigate to="/login" />} />
          <Route path="/datasource" element={auth ? <DataSource /> : <Navigate to="/login" />} />
          <Route path="/usecase" element={auth ? <UseCase /> : <Navigate to="/login" />} />
          <Route path="/usecaseDetails" element={auth ? <UseCaseDetails /> : <Navigate to="/login" />} />
          <Route path="/creditRisk" element={auth ? <CreditRisk /> : <Navigate to="/login" />} />
          <Route path="/action" element={auth ? <Action /> : <Navigate to="/login" />} />
          <Route path="/About us" element={auth ? <AboutUs /> : <Navigate to="/login" />} />
          <Route path="/Login" element={<Login />} />
          <Route path="/" element={auth ? <Upload /> : <Navigate to="/login" />} />
          <Route path="/billing" element={auth ? <Billing /> : <Navigate to="/login" />} />
          <Route path="/Registration" element={<Registration />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/password-reset" element={<ResetPassword />} />
          <Route path="/account-activation" element={<AccountActivation />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        {/* Footer with links to Privacy Policy and Terms of Service */}
        <Footer />
      </Router>
      {/* Cookie Consent banner appears on every page until consent is given */}
      <CookieConsent
        location="bottom"
        buttonText="I understand"
        cookieName="cookieConsent"
        style={{ background: "#2B373B" }}
        buttonStyle={{ color: "#4e503b", fontSize: "13px" }}
        expires={150}
      >
        This website uses cookies to enhance the user experience.
      </CookieConsent>
    </>
  );
}

export default App;
